<!--
  ~ Created by Yaroslav S. on 16/04/24.
  ~ Copyright © 2024 SEVEN. All rights reserved.
-->

<div fxLayout="row" fxLayoutAlign="space-between start" class="share-header m-b-8">
  <div class="confirm-title" fxFlex>{{dialogTitle}}</div>
  <mat-icon [svgIcon]="'close'" (click)="dialogRef.close()"></mat-icon>
</div>
<div fxLayout="column" fxLayoutAlign="center center">
  <div class="confirm-content">
    <div class="sliders" *ngIf="isSliderLoader">
      <div class="sliders-loader">
        <mat-spinner [strokeWidth]="5" [diameter]="56"></mat-spinner>
      </div>
    </div>
    <table class="grades-table" *ngIf="grades && grades.length">
      <thead>
      <tr>
        <th class="col-20" *ngIf="!grades[0].useGcse">A-Level</th>
        <th class="col-20" *ngIf="grades[0].useGcse">GCSE</th>
        <th class="col-60">Range</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let g of grades; let i = index">
        <td class="col-20" *ngIf="!g.useGcse">{{ g.grade }}</td>
        <td class="col-20" *ngIf="g.useGcse">{{ g.gcseGrade }}</td>
        <td class="col-60">
          <div class="slider-wrapper">
            <ngx-slider
              [(value)]="g.from"
              [(highValue)]="g.to"
              [options]="options"
              (userChangeEnd)="onChangeGrade(i)">
            </ngx-slider>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="m-t-40 full-width" fxLayout="row" fxLayoutAlign="end center">
    <curr-button variant="text" (btnClick)="dialogRef.close()" size="big">Continue Checking</curr-button>
    <curr-button variant="text" class="m-l-16" (btnClick)="confirm()" size="big">Share</curr-button>
  </div>
</div>
